import { faText } from '@fortawesome/pro-regular-svg-icons';
import React, { useContext, useState } from 'react';
import './AddContentCard.module.scss';
import CircleButton from 'components/UI/CircleButton/CircleButton';
import { faFolder } from '@fortawesome/pro-solid-svg-icons';
import { useDispatch } from 'react-redux';
import createEvidence from 'actions/evidence/store';
import updatePortfolio from 'actions/portfolio/update';
import UploadModal from 'components/UI/UploadModal/UploadModal';
import { MyPortfolioContext } from '../../MyPortfolio';

export default function AddContentCard() {
  const { currentPortfolioId } = useContext(MyPortfolioContext);

  const [uploadModalOpen, setUploadModalOpen] = useState(false);

  const dispatch = useDispatch();

  const addTextToPortfolio = () => {
    dispatch(
      createEvidence({
        metadata: {
          title: '',
          text: '',
        },
        storeForPortfolio: true,
      })
    ).then((evidence) => {
      dispatch(
        updatePortfolio({
          attachEvidence: true,
          portfolios: [currentPortfolioId],
          evidence: evidence.id,
        })
      );
    });
  };

  const handleUpload = (file) => {
    if (typeof file === 'string') {
      dispatch(
        createEvidence({
          link: file,
          storeForPortfolio: true,
        })
      ).then((evidence) => {
        dispatch(
          updatePortfolio({
            attachEvidence: true,
            portfolios: [currentPortfolioId],
            evidence: evidence.id,
          })
        );
      });
    } else {
      dispatch(
        createEvidence({
          file,
          storeForPortfolio: true,
        })
      ).then((evidence) => {
        dispatch(
          updatePortfolio({
            attachEvidence: true,
            portfolios: [currentPortfolioId],
            evidence: evidence.id,
          })
        );
      });
    }
  };

  return (
    <>
      <div styleName="wrapper">
        <div styleName="icons">
          <CircleButton
            onClick={addTextToPortfolio}
            color="white-text"
            icon={faText}
          />
          <CircleButton
            onClick={() => setUploadModalOpen(true)}
            color="white-text"
            icon={faFolder}
          />
        </div>
      </div>

      {uploadModalOpen && (
        <UploadModal
          setModalIsOpen={setUploadModalOpen}
          handleUpload={handleUpload}
        />
      )}
    </>
  );
}
